export const initialValues = {
  id: "",
  split_payroll_country_id: "",
  country_id: "",
  tax_year: "",
  is_foreign_tax_liable: 0,
  default_social_security_percentage: 0,
};
